import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PlotLegendData } from '../models/plot-legend-data.model';
import { PlotLegendItemClicked } from '../models/plot-legend-item-clicked.model';

@Component({
  standalone: true,
  selector: 'app-plot-legend',
  imports: [CommonModule, MatInputModule, MatTableModule],
  templateUrl: './plot-legend.component.html',
  styleUrl: './plot-legend.component.scss',
})
export class PlotLegendComponent implements OnInit, OnChanges {
  @Input({ required: true }) title = '';
  @Input({ required: true }) data: PlotLegendData[] = [];
  @Input({ required: true }) labelOnly = false; // True to show only the label column with the color box, without count/percentage
  @Input({ required: true }) static = false; // True to display rows with styles not indicating any form of interaction upon clicking/hovering
  @Output() rowClicked = new EventEmitter<PlotLegendItemClicked>();

  protected tableColumns: string[] = [];
  protected tableDataSource = new MatTableDataSource<PlotLegendData>();
  protected percentageSelected = true;

  public ngOnInit(): void {
    this.tableDataSource.data = this.data;
    this.tableColumns = this.labelOnly ? ['label'] : ['label', 'metric'];
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // Data may be changed from the parent component and we need to reload the data.
    if (changes['data'] && !changes['data'].firstChange) {
      this.tableDataSource.data = this.data;
    }
  }

  protected onRowSelected(row: PlotLegendData, index: number): void {
    this.rowClicked.emit({ row, index } as PlotLegendItemClicked);
  }

  protected onCountSwitchButtonClicked(): void {
    this.percentageSelected = false;
  }

  protected onPercentageSwitchButtonClicked(): void {
    this.percentageSelected = true;
  }
}
